// extracted by mini-css-extract-plugin
module.exports = {"promos-list":"_02712f2b3b--promos-list--Cv3RA","container":"_02712f2b3b--container--l034S"};